import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useGetExchangeRates from '../../../common/category/useGetExchangeRates'
import useDidUpdateEffect from '../../../common/hooks/useDidUpdateEffect'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Checkbox } from '../../../common/html/checkbox'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { Input } from '../../../common/html/input'
import { PopupAction } from '../../../common/popup/PopupAction'
import { Tooltip } from '../../../common/tooltip'
import { debounce } from '../../../helpers/common'
import {
  formatCurrency,
  formatText,
  valToPercent,
} from '../../../helpers/value'
import { EMPTY_VALUE, Z_INDEX } from '../../../utils/common'
import { CURRENCY } from '../../../utils/currency'
import { CHECKBOX_TRADE_DISCOUNT } from '../../constant'
import { formatPrice } from '../../helper'
import {
  changeCheckDiscountAndVoucher,
  changeVoucher,
  selectCheckDisCountAndVoucher,
  selectDiscountOrder,
  selectTotalPrice,
  selectVoucher,
} from '../../store/slice'
import { getVoucher } from '../../store/thunk'
import classes from './index.module.scss'

export const TradeDiscountPopup = ({
  isShow,
  onClose,
  pricePackage,
  isDiscount,
  priceDiscountDetails,
}) => {
  const dispatch = useDispatch()

  const { exchangeRates } = useGetExchangeRates()

  const [code, setCode] = useState('')
  const [isValid, setValid] = useState(false)
  const [dataVoucher, setDataVoucher] = useState()
  const [isCheck, setCheck] = useState(false)

  const locale = useSelector((state) => state.i18n.locale)
  const priceCart = useSelector(selectTotalPrice('discountedPrice'))
  const discountOrder = useSelector(selectDiscountOrder)
  const checkDiscountAndVoucher = useSelector(selectCheckDisCountAndVoucher)
  const discountVoucher = useSelector(selectVoucher)

  const {
    totalPrice,
    totalPackageDiscountProduct,
    subscription,
    package: packageDetail,
  } = priceDiscountDetails || {}

  const discountPriceOrder = pricePackage ? pricePackage : priceCart
  const totalPriceNoDiscountProduct =
    priceDiscountDetails && totalPrice
      ? totalPrice - (totalPackageDiscountProduct || 0)
      : discountPriceOrder

  const priceDiscountOrder = formatCurrency(
    formatPrice(
      priceDiscountDetails
        ? subscription.price + packageDetail.price
        : discountPriceOrder * discountOrder?.discountPercentage,
    ),
    CURRENCY.USD,
    CURRENCY.VND,
    exchangeRates,
    locale,
  )

  const priceDiscountVoucher = formatCurrency(
    formatPrice(
      dataVoucher?.discountPercentage
        ? totalPriceNoDiscountProduct * dataVoucher?.discountPercentage
        : dataVoucher?.discountAmount,
    ),
    CURRENCY.USD,
    CURRENCY.VND,
    exchangeRates,
    locale,
  )

  const percent = valToPercent(
    discountOrder?.discountPercentage || 0,
    locale,
    false,
    false,
    0,
  )

  const titleTradeDistcount =
    UseI18n('cartAndOrders.orderInformation.discount') +
    ': ' +
    (isDiscount && typeof priceDiscountDetails === 'object'
      ? ''
      : discountOrder?.name)

  const onChangeCode = (e) => {
    setCode(e.target.value)
  }

  const handleChangeText = useCallback(
    debounce((value) => {
      if (!value) {
        setValid(false)
        return
      }
      dispatch(
        getVoucher({
          Code: value,
        }),
      )
        .unwrap()
        .then((value) => {
          setValid(false)
          setDataVoucher(value)
        })
        .catch(() => {
          setDataVoucher({})
          setValid(true)
        })
    }, 700),
    [],
  )

  const onSubmit = () => {
    if (isCheck && (!code || isValid)) {
      setValid(true)
      return
    }
    if (!isCheck) {
      setValid(false)
      setDataVoucher({})
      setCode('')
      setCheck(false)
      dispatch(
        changeCheckDiscountAndVoucher({
          [CHECKBOX_TRADE_DISCOUNT.VOUCHER]: false,
        }),
      )
      dispatch(changeVoucher({}))
    } else {
      dispatch(
        changeCheckDiscountAndVoucher({
          [CHECKBOX_TRADE_DISCOUNT.VOUCHER]: isCheck,
        }),
      )
      dispatch(changeVoucher(dataVoucher))
    }
    onClose()
  }

  const handleClose = () => {
    onClose()
    if (isCheck && (!code || isValid)) {
      setValid(false)
      setDataVoucher({})
      setCode('')
      setCheck(false)
      dispatch(
        changeCheckDiscountAndVoucher({
          [CHECKBOX_TRADE_DISCOUNT.VOUCHER]: false,
        }),
      )
    }
  }

  const onChangeCheckbox = (value) => {
    setCheck(value)
  }

  useEffect(() => {
    setCheck(checkDiscountAndVoucher[CHECKBOX_TRADE_DISCOUNT.VOUCHER])
    setDataVoucher(discountVoucher)
    setCode(discountVoucher?.code || '')
  }, [])

  useDidUpdateEffect(() => {
    handleChangeText(code)
  }, [code])

  return (
    <PopupAction
      title="cartAndOrders.tradeDiscount.select"
      isShow={isShow}
      handleClose={handleClose}
      btnSubmit={{
        label: 'cartAndOrders.tradeDiscount.apply',
        event: onSubmit,
        isI18n: true,
      }}
      btnCancel={{
        label: 'cartAndOrders.tradeDiscount.cancel',
        event: handleClose,
        isI18n: true,
      }}
    >
      <div className="fw600">
        {!!discountOrder?.name && (
          <div
            className={`dFlex justifyContentBetween alignItemsCenter ${classes.pb12}`}
          >
            <Checkbox
              value={CHECKBOX_TRADE_DISCOUNT.DISCOUNT}
              checked={
                checkDiscountAndVoucher[CHECKBOX_TRADE_DISCOUNT.DISCOUNT]
              }
              onChange={(value) =>
                onChangeCheckbox(value, CHECKBOX_TRADE_DISCOUNT.DISCOUNT)
              }
              title={
                discountOrder?.name
                  ? formatText(titleTradeDistcount)
                  : EMPTY_VALUE
              }
              mlTitle={5}
              isI18n={false}
              styleIcon={{
                opacity: 0.6,
              }}
              allowChange={false}
            />
            <div className="whiteSpaceNowrap">
              {isDiscount && typeof priceDiscountDetails === 'object' ? (
                <>
                  <CustomPriceDouble
                    price={priceDiscountOrder}
                    priceDiscountDetails={priceDiscountDetails}
                    locale={locale}
                    exchangeRates={exchangeRates}
                  />
                </>
              ) : (
                <>
                  {percent} ~ {priceDiscountOrder}
                </>
              )}
            </div>
          </div>
        )}

        <div
          className={`dFlex justifyContentBetween alignItemsCenter ${classes.pb12}`}
        >
          <div className="dFlex w100 alignItemsCenter">
            <Checkbox
              value={CHECKBOX_TRADE_DISCOUNT.VOUCHER}
              checked={isCheck}
              onChange={(value) =>
                onChangeCheckbox(value, CHECKBOX_TRADE_DISCOUNT.VOUCHER)
              }
              title="Voucher:"
              mlTitle={5}
              isI18n={false}
              titleStyle={{ marginRight: 8 }}
            />
            &ensp;
            {isCheck && (
              <>
                <Input
                  containerStyle={{ flex: 1 }}
                  placeHolder="cartAndOrders.tradeDiscount.enter"
                  value={code}
                  onChange={onChangeCode}
                  isShowIcon={false}
                  isValid={!isValid}
                  textInvalid={
                    !code
                      ? 'cartAndOrders.message.m21'
                      : 'cartAndOrders.message.m19'
                  }
                />
                <>
                  {!!dataVoucher?.discountPercentage ? (
                    <div className="whiteSpaceNowrap ml1">
                      {valToPercent(
                        dataVoucher?.discountPercentage || 0,
                        locale,
                        false,
                        false,
                        0,
                      )}
                      ~&nbsp;
                      {priceDiscountVoucher}
                    </div>
                  ) : dataVoucher?.discountAmount ? (
                    <div className="whiteSpaceNowrap ml1">
                      {priceDiscountVoucher}
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              </>
            )}
          </div>
        </div>
      </div>
    </PopupAction>
  )
}

export const CustomPriceDouble = ({
  priceDiscountDetails,
  price,
  locale,
  exchangeRates,
}) => {
  const { package: packageDetail, subscription } = priceDiscountDetails
  return (
    <>
      <Element className="dFlex gap1">
        <span>{price}</span>
        <Tooltip
          tooltipContent={
            <div style={{ width: 350 }}>
              <div className="w100">
                <table className="w100">
                  <tbody>
                    {subscription?.id && (
                      <>
                        <tr>
                          <td colSpan={2}>
                            <div>
                              <Translate value="userManagement.packageSubManagement.SUBSCRIPTION" />
                              :
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="ml1">{subscription.name}</div>
                          </td>
                          <td>
                            <div className="w100" style={{ textAlign: 'end' }}>
                              {subscription.discountPercentage * 100}% ~{' '}
                              {formatCurrency(
                                subscription.price,
                                CURRENCY.USD,
                                CURRENCY.VND,
                                exchangeRates,
                                locale,
                              )}
                            </div>
                          </td>
                        </tr>
                      </>
                    )}
                    {packageDetail?.id && (
                      <>
                        <tr>
                          <td colSpan={2}>
                            <div>
                              <Translate value="userManagement.packageSubManagement.PACKAGE" />
                              :
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="ml1">{packageDetail.name}</div>
                          </td>
                          <td>
                            <div className="w100" style={{ textAlign: 'end' }}>
                              {packageDetail.discountPercentage * 100}% ~{' '}
                              {formatCurrency(
                                packageDetail.price,
                                CURRENCY.USD,
                                CURRENCY.VND,
                                exchangeRates,
                                locale,
                              )}
                            </div>
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          }
          zIndex={Z_INDEX.MODAL + 1}
        >
          <Icon
            className="icon-info-circle"
            style={{ fontSize: 14, color: '#9C9C9C' }}
          />
        </Tooltip>
      </Element>
    </>
  )
}
